<template>
  <!--
      作者 luoyiming
      时间：2020-06-09
      描述：会员-余额明细
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="订单号">
          <el-input v-model="formInline.orderNo" placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item label="技师ID">
          <el-input v-model="formInline.waiter_user_id" placeholder="请输入技师ID"></el-input>
        </el-form-item>
        <el-form-item label="起始日期">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.createTime" type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="orderId" label="订单ID" width="80"></el-table-column>
          <el-table-column prop="orderNo" label="订单编号">
            <template slot-scope="scope">
              <div style="text-decoration: underline ;color: rgb(0, 141, 223)" @click="goOrderDetail(scope.row.orderId)">
                {{ scope.row.orderNo }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="payPrice" label="实际支付金额">
            <template slot-scope="scope">
              <div style="color:red">￥{{ scope.row.payPrice }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="totalPrice" label="项目金额">
            <template slot-scope="scope">
              <div style="color:#9fe6b8">￥{{ scope.row.totalPrice }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="clockPrice" label="加钟金额">
            <template slot-scope="scope">
              <div style="color:#E6A23C">￥{{ scope.row.clockPrice ? scope.row.clockPrice : 0.00 }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="addClock_scale" label="加钟技师比例"></el-table-column>
          <el-table-column prop="farePrice" label="车费金额">
            <template slot-scope="scope">
              <div style="color:#8378ea">￥{{ scope.row.farePrice ? scope.row.farePrice : 0.00 }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="vipPrice" label="会员优惠金额">
            <template slot-scope="scope">
              <div style="color:#ffa500">￥{{ scope.row.vipPrice ? scope.row.vipPrice : 0.00 }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="couponMoney" label="优惠券金额">
            <template slot-scope="scope">
              <div style="color:#008000">￥{{ scope.row.couponMoney ? scope.row.couponMoney : 0.00 }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="basicPrice" label="分佣基数"></el-table-column>
          <el-table-column prop="waiterScale" label="技师比例"></el-table-column>
          <el-table-column prop="supplierScale" label="商户比例"></el-table-column>
          <el-table-column prop="sysScale" label="平台比例"></el-table-column>
          <el-table-column prop="waiterPrice" label="技师所得分佣">
            <template slot-scope="scope">
              <div style="color:orange">￥{{ scope.row.waiterPrice }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="supplierPrice" label="商户分佣">
            <template slot-scope="scope">
              <div style="color:#1ba035">￥{{ scope.row.supplierPrice }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="sysPrice" label="平台分佣">
            <template slot-scope="scope">
              <div style="color:red">￥{{ scope.row.sysPrice }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="userPromotionPrice" label="一级用户推广员分佣"></el-table-column>
          <el-table-column prop="twoUserPromotionPrice" label="二级用户推广员分佣"></el-table-column>
          <el-table-column prop="userPromotionPrice" label="一级技师推广员分佣"></el-table-column>
          <el-table-column prop="twoUserPromotionPrice" label="二级技师推广员分佣"></el-table-column>
          <el-table-column prop="generalAgencyPrice" label="一级渠道代理分佣"></el-table-column>
          <el-table-column prop="secondaryAgencyPrice" label="二级渠道代理分佣"></el-table-column>
          <el-table-column prop="secondaryAgencyPrice" label="渠道用户分佣"></el-table-column>
          <el-table-column prop="channelAgentPrice" label="渠道代理分佣"></el-table-column>
          <el-table-column prop="servicePrice" label="服务费扣款">
            <template slot-scope="scope">
              <div style="color:#ffc0cb">￥{{ scope.row.servicePrice ? scope.row.servicePrice : 0.00 }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="handlingPrice" label="提现手续费">
            <template slot-scope="scope">
              <div style="color:#8b008b">￥{{ scope.row.handlingPrice ? scope.row.handlingPrice : 0.00 }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="storedPrice" label="储值扣款">
            <template slot-scope="scope">
              <div style="color:#3a34fd">￥{{ scope.row.storedPrice ? scope.row.storedPrice : 0.00 }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="waiter.avatarUrl" label="头像" width="70">
            <template slot-scope="scope" v-if="scope.row.waiter && scope.row.waiter.avatarUrl">
              <img :src="scope.row.waiter.avatarUrl" width="30" height="30" />
            </template>
          </el-table-column>
          <el-table-column prop="user.username" label="姓名">
            <template slot-scope="scope" v-if="scope.row.waiter">
              <span>{{ scope.row.waiter.username }}</span>
              <span class="gray9">(技师ID：{{ scope.row.waiter.waiterUserId }})</span>
            </template>
          </el-table-column>
          <el-table-column prop="pay_time" label="支付时间" width="140"></el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import CashApi from "@/api/cash.js";
export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        waiterUserId: "",
        createTime: "",
        orderNo: ""
      },
      /*场景*/
      Scene: [],
      /*时间*/
      value1: ""
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    goOrderDetail(orderId) {
      this.$router.push({
        path: "/order/order/Detail?orderId=1442",
        query: {
          orderId: orderId
        }
      });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.formInline;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      CashApi.orderLog(Params, true)
        .then(data => {
          //  console.log(data.data.list.data);
          self.loading = false;
          self.tableData = data.data.data;
          self.totalDataNumber = data.data.total;
        })
        .catch(error => { });
    },

    /*搜索查询*/
    onSubmit() {
      let self = this;
      self.loading = true;
      this.curPage = 1;
      let Params = self.formInline;
      self.getTableList();
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "add") {
        this.open_add = e.openDialog;
        if (e.type == "success") {
          this.getTableList();
        }
      }
      if (f == "edit") {
        this.open_edit = e.openDialog;
        if (e.type == "success") {
          this.getTableList();
        }
      }
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/cash/ordermoney/index.vue